import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import { isLoading } from "Modules/Loading"
import { isLoader } from "Modules/Loader"
import Socket from 'Assets/Socket'

const initialState = Immutable.Map({})
	.set('Get', new Immutable.List([]))
	.set('Response', new Immutable.List([]))
	.set('Search', new Immutable.List([]))
	.set('Uid', new Immutable.Map({}))
	.set('Socket', new Immutable.Map({}))
	.set('Detail', new Immutable.Map({}))
	.set('Certificate', new Immutable.Map({}))
	.set('GetHTML', new Immutable.Map({}))
	.set('ProposalForCertificate', new Immutable.Map({}))
	.set('GenerateCertificate', new Immutable.Map({}))
	.set('ProposalByEjec', new Immutable.Map({}))

/* Types */
export const GET_OPENED_EVENTS = 'GET_OPENED_EVENTS'
export const GET_PROPOSAL = 'GET_PROPOSAL'
export const GET_EVALUATIONS_BY_EVENT = 'GET_EVALUATIONS_BY_EVENT'
export const EXECUTE_FUNCTION = 'EXECUTE_FUNCTION'
export const SOCKET = 'SOCKET'
export const GET_PROPOSAL_DETAIL = 'GET_PROPOSAL_DETAIL'
export const SAVE_CERTIFICATE = 'SAVE_CERTIFICATE'
export const ACTION_SET_VARIABLE_HTML = 'ACTION_SET_VARIABLE_HTML'
export const GET_PROPOSAL_CERTIFICATE = 'GET_PROPOSAL_CERTIFICATE'
export const GENERATE_CERTIFICATE = 'GENERATE_CERTIFICATE'
export const GET_PROPOSAL_BY_EJECT = 'GET_PROPOSAL_BY_EJECT'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case GET_OPENED_EVENTS:
			return state.set('Get', new Immutable.List(action.Obj))
		case GET_PROPOSAL:
			return state.set('Response', new Immutable.List(action.Obj))
		case GET_EVALUATIONS_BY_EVENT:
			return state.set('Search', new Immutable.List(action.Obj))
		case EXECUTE_FUNCTION:
			return state.set('Uid', new Immutable.Map(action.Obj))
		case SOCKET:
			return state.set('Socket', new Immutable.Map(action.Obj))
		case GET_PROPOSAL_DETAIL:
			return state.set('Detail', new Immutable.Map(action.Obj))
		case SAVE_CERTIFICATE:
			return state.set('Certificate', new Immutable.Map(action.Obj))
		case GENERATE_CERTIFICATE:
			return state.set('GenerateCertificate', new Immutable.Map(action.Obj))
		case GET_PROPOSAL_CERTIFICATE:
			return state.set('ProposalForCertificate', new Immutable.Map(action.Obj))
		case ACTION_SET_VARIABLE_HTML:
			return state.set('GetHTML', new Immutable.Map(action.Obj))
		case GET_PROPOSAL_BY_EJECT:
			return state.set('ProposalByEjec', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const getOpenedEvents = () => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getOpenedEvents',
			method: "POST",
			data: {},
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: GET_OPENED_EVENTS, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getProposal = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getProposal',
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			let data = response.data
			data = data.map((d) => {
				d.uniqueId = Utils.getUUID()
				return d
			})
			dispatch({ type: GET_PROPOSAL, Obj: data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getEvaluationsByEvent = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getEvaluationsByEvent',
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			response.data.uniqueId = Utils.getUUID()
			dispatch({ type: GET_EVALUATIONS_BY_EVENT, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const executeFunction = (form) => {

	let evaluaciones = []

	if (form.evaluaciones) {
		evaluaciones = form.evaluaciones.split(",").map(e => e )
	}

	let temp = {
		configuracionFuncionId: form.funcion,
		presupuestoProgramaAsociado: form.montoProgramaAsociadoFuncion || null,
		corridaId: form.corrida,
		evaluaciones: evaluaciones || [],
		funcion: form.tipoFuncion,
		redondeo: form.redondeo,
		usuario: sessionStorage.uid
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/executeFunction',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: EXECUTE_FUNCTION, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getProposalDetail = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getProposalDetail',
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			response.data.uniqueId = Utils.getUUID()
			dispatch({ type: GET_PROPOSAL_DETAIL, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const editProposal = (form) => {

	let temp = {
		causaNegacionId: form.causaNegacionId,
		comentarios: form.comentarios,
		donatariaId: form.donatariaId,
		montoProgramaAsociado: form.montoPrograma,
		montoPropuesto: form.montoPropuesto,
		propuestaId: form.propuestaId,
		resultadoAsignacionId: form.resultadoAsignacionId,
		solicitadoProgramaAsociado: form.solicitadoPrograma,
		usuario: sessionStorage.uid
	}

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/editProposal',
			method: "POST",
			data: { ...temp },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const validateProposal = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/validateProposal',
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const saveCertificate = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		let adapterForm = {
			certificadoId: form.certificadoId && form.certificadoId !== null ? form.certificadoId : 0,
			propuestaId: form.propuesta.propuestaId,
			dropboxId: form.logotipo,
			texto1: form.texto1,
			texto2: form.texto2,
			texto3: form.texto3,
			texto4: form.textEditor,
			texto5: form.texto5,
			texto6: form.texto6,
			texto7: form.texto7,
			piePagina: form.pieDePagina,
			firma1: form.firma1,
			firma2: form.firma2,
			firma3: form.texto7Firma1,
			firma4: form.texto7Firma2,
			usuario: sessionStorage.uid
		}

		adapterForm.participantesDTO = []
		adapterForm.equiposTrabajoDTO = []

		form.signs.map((item) => {
			adapterForm.participantesDTO.push({
				apellidoMaterno: item.maternoOriginal,
				apellidoPaterno: item.paternoOriginal,
				nombre: item.nombreOriginal,
				puesto: item.puesto,
				titulo: item.titulo
			})
		})

		form.body.map((item) => {
			let auxArrayParticipantes = []

			item.original.map(data => {
				auxArrayParticipantes.push({ firmaParticipanteEquipo: data.firma })
			})

			adapterForm.equiposTrabajoDTO.push({
				participantesEquipoDTO: auxArrayParticipantes,
				texto8: item.texto8,
				texto9: item.texto9
			})
		})

		return new ClientHttpRequest({
			service: 'api/saveCertificate',
			method: "POST",
			data: { ...adapterForm },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: SAVE_CERTIFICATE, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})


	}
}

export const generateCertificate = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		let adapterForm = {
			certificadoId: form.certificadoId && form.certificadoId !== null ? form.certificadoId : 0,
			propuestaId: form.propuesta.propuestaId,
			dropboxId: form.logotipo,
			texto1: form.texto1,
			texto2: form.texto2,
			texto3: form.texto3,
			texto4: form.textEditor,
			texto5: form.texto5,
			texto6: form.texto6,
			texto7: form.texto7,
			piePagina: form.pieDePagina,
			firma1: form.firma1,
			firma2: form.firma2,
			firma3: form.texto7Firma1,
			firma4: form.texto7Firma2,
			usuario: sessionStorage.uid
		}

		adapterForm.participantesDTO = []
		adapterForm.equiposTrabajoDTO = []

		form.signs.map((item) => {
			adapterForm.participantesDTO.push({
				apellidoMaterno: item.maternoOriginal,
				apellidoPaterno: item.paternoOriginal,
				nombre: item.nombreOriginal,
				puesto: item.puesto,
				titulo: item.titulo
			})
		})

		form.body.map((item) => {
			let auxArrayParticipantes = []

			item.original.map(data => {
				auxArrayParticipantes.push({ firmaParticipanteEquipo: data.firma })
			})

			adapterForm.equiposTrabajoDTO.push({
				participantesEquipoDTO: auxArrayParticipantes,
				texto8: item.texto8,
				texto9: item.texto9
			})
		})

		return new ClientHttpRequest({
			service: 'api/generateCertificate',
			method: "POST",
			data: { ...adapterForm },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid }),
			responseType: 'arraybuffer'
		}).request().then(response => {
			dispatch(isLoading(false))

			const blob = new Blob([response.data], { type: 'application/pdf' })
			const fileName = `certificado-${Utils.getToday()}.pdf`
			const objectUrl = URL.createObjectURL(blob)
			const a = document.createElement('a')

			a.href = objectUrl
			a.download = fileName
			document.body.appendChild(a)
			a.click()

			document.body.removeChild(a)
			URL.revokeObjectURL(objectUrl)
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})

	}
}

export const getItemProposalForCertificate = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getItemProposalForCertificate',
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: GET_PROPOSAL_CERTIFICATE, Obj: response.data })
			return response.data
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const setVaribleToHTML = (form) => {

	return (dispatch) => {
		dispatch({ type: ACTION_SET_VARIABLE_HTML, Obj: form })
		let promise = new Promise(function (resolve) {
			resolve(form);
		})
		return promise
	}
}

export const socketConnection = () => {
	return (dispatch) => {
		dispatch(isLoader(true))
		let client = Socket()
		client.receive(dispatch, SOCKET)
	}
}

export const closeSocketConnection = () => {
	return (dispatch) => {
		dispatch(isLoader(false))
		let promise = new Promise(function (resolve) {
			resolve()
		})
		return promise
	}
}

export const clearProposalDetail = () => {
	return (dispatch) => {
		dispatch({ type: GET_PROPOSAL_DETAIL, Obj: {} })
	}
}

export const getProposalByEjec = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getProposalByEjec',
			method: "POST",
			data: { ...form },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: GET_PROPOSAL_BY_EJECT, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const clearItem = () => {
	return (dispatch) => {
		dispatch({ type: GET_PROPOSAL_BY_EJECT, Obj: {} }),
			dispatch({ type: GET_PROPOSAL_DETAIL, Obj: {} })

	}
}




// WEBPACK FOOTER //
// ./src/modules/Filter/ProposalAssignment.js